// extracted by mini-css-extract-plugin
export default {"page":"QZ-z","cartModal":"RZ-z","checkout":"SZ-z","placeholder":"TZ-z","account":"UZ-z"};